import Vue from 'vue'
import Vuex from 'vuex'

import common from './common'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

const Store = new Vuex.Store({
  modules: {
    common
  }
})

export default Store



// WEBPACK FOOTER //
// ./src/store/index.js